// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FileTwoToneSvg from "@ant-design/icons-svg/lib/asn/FileTwoTone";
import AntdIcon from "../components/AntdIcon";
const FileTwoTone = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FileTwoToneSvg
    });
if (process.env.NODE_ENV !== "production") {
    FileTwoTone.displayName = "FileTwoTone";
}
export default /*#__PURE__*/ React.forwardRef(FileTwoTone);
